import React, { useRef, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Chip, IconButton, Menu } from '@mui/material';

interface Props {
  label: string;
  /** Optional menu content shown from the tag's action chevron. */
  dropdownContent?: React.ReactNode;
}

export default function ReportingTag({ label, dropdownContent }: Props) {
  const actionButtonRef = useRef<HTMLButtonElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const closeDropdown = () => setIsDropdownOpen(false);

  return (
    <>
      <Box
        sx={{ alignItems: 'center', display: 'inline-flex' }}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => event.stopPropagation()}
      >
        <Chip size="small" variant="outlined" label={label} title={label} />
        {dropdownContent && (
          <IconButton
            ref={actionButtonRef}
            aria-label={`Open actions for ${label}`}
            aria-expanded={isDropdownOpen}
            aria-haspopup="menu"
            size="small"
            onClick={() => setIsDropdownOpen(true)}
            sx={{ ml: -0.5, p: 0.25 }}
          >
            <KeyboardArrowDownIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      {dropdownContent && (
        <Menu anchorEl={actionButtonRef.current} open={isDropdownOpen} onClose={closeDropdown} onClick={closeDropdown}>
          {dropdownContent}
        </Menu>
      )}
    </>
  );
}
